import { render, staticRenderFns } from "./workspaces_dropdown_group.vue?vue&type=template&id=24d5be94"
import script from "./workspaces_dropdown_group.vue?vue&type=script&lang=js"
export * from "./workspaces_dropdown_group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports